var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H17C18.6569 14 20 12.6569 20 11V3C20 1.34315 18.6569 0 17 0H3ZM2 3.21304V11C2 11.2062 2.06242 11.3979 2.16941 11.5571L6.9465 7.57616L2 3.21304ZM8.54802 8.84497L4.76199 12H15.2381L11.452 8.84491C11.0037 9.06927 10.5068 9.18795 9.99995 9.18795C9.49314 9.18795 8.99634 9.06929 8.54802 8.84497ZM18 11C18 11.2062 17.9376 11.3978 17.8306 11.557L13.0535 7.57607L18 3.21295V11ZM16.3517 2H3.64821L9.1693 6.86993C9.21039 6.90586 9.22583 6.91844 9.2387 6.9281L9.24515 6.93293C9.46202 7.09833 9.7272 7.18795 9.99995 7.18795C10.2727 7.18795 10.5379 7.09836 10.7548 6.93296L10.7612 6.92807C10.7741 6.91841 10.7895 6.90586 10.8306 6.86993L10.8321 6.86865L16.3517 2Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ba23dea5feb58e91611be5490fde3a2a.svg";
export { ForwardRef as ReactComponent };